import {all, call, delay, put, race, select, take, takeEvery} from 'redux-saga/effects';
import axios from 'axios';
import {normalize} from 'normalizr';
import {ORGANIZATIONS, UPLOADED_FILE} from "src/api/api-schemas";
import {setEntities} from "src/features/entity";
import {getSelectedOrganizationId, selectOrganization, setOrganizations} from "src/features/dashboard/dashboard-slice";
import {getSessionData, loginSuccess, logout, logoutSuccess} from '../session';
import {uploadedFile, uploadFailed, uploadFile} from "./dashboard-slice";

function* fetchOrganizations() {
  while (true) {
    try {
      const response = yield call(axios.get, `/api/sendemeldung/organizations/?page_size=1000`);
      if (!response.data) {
        // noinspection ExceptionCaughtLocallyJS
        throw new Error("fetch organizations failed");
      }

      // TODO: Handle pagination.

      const organizations = response.data?.results;
      const normalizedOrganizations = normalize(organizations, ORGANIZATIONS);

      yield put(setEntities(normalizedOrganizations));
      if (organizations?.length > 0) {
        const selectedOrganizationId = yield select(getSelectedOrganizationId);
        if (!normalizedOrganizations?.result?.includes(selectedOrganizationId)) {
          yield put(selectOrganization({organization: organizations[0].id}));
        }
      }
      yield put(setOrganizations({organizations: normalizedOrganizations.result}));

      break;
    } catch (e) {
      console.error(e);
      if (e.isAxiosError && e.response?.status === 401) {
        yield put(logout());
        break;
      }
      yield delay(500);
    }
  }
}

function* dataSaga() {
  while (true) {
    // Wait for session data to become available.
    let active;
    while (!active) {
      const sessionData = yield select(getSessionData);
      active = sessionData.active;

      if (!active) {
        // Wait for login or state rehydration.
        yield take([loginSuccess]);
      }
    }

    yield race({
      fetchOrganizations: call(fetchOrganizations),
      logoutTimeout: take([logoutSuccess]),
      timeout: delay(5000),
    });

    // Start over after logout or when another organization is selected (so that we refresh the list of organizations).
    yield take([logoutSuccess, selectOrganization]);
  }
}

function* watchUploadFile(action) {
  const {internalId, name, size, blob} = action.payload;

  let data = new FormData();
  data.append('name', name);
  data.append('file', blob);

  for (let i = 0; i < 4; i++) {
    let response;
    try {
      const organizationId = yield select(getSelectedOrganizationId);

      // yield delay(2000);

      response = yield call(axios.post, `/api/sendemeldung/organizations/${organizationId}/uploaded_files/`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (e) {
      console.error(e);
      yield delay(i * 1000);
      continue;
    }

    if (response.status === 201) {
      yield put(uploadedFile({internalId, name, size, ...response.data}));

      const uploadedFileData = response.data;
      const normalizedUploadedFile = normalize(uploadedFileData, UPLOADED_FILE);

      yield put(setEntities({
        ...normalizedUploadedFile,
        created: true,
        createdForOrganization: uploadedFileData.organization,
      }));
      return;
    } else {
      yield delay(i * 1000);
    }
  }

  yield put(uploadFailed({internalId}));
}


export default function* rootSaga() {
  yield takeEvery(uploadFile, watchUploadFile);

  yield all([
    call(dataSaga),
  ]);
}
